@if (showMarketHelp) {
    <ms-market-help [optionGroup]="optionGroup" [eventHelpText]="eventHelpText" />
}
<div class="option-group-container six-pack-container" [ngClass]="tupleClass">
    <div class="option-group-header">
        <span class="six-pack-team"></span>
        @if (showSixPackParticipantImages) {
            <div class="options-header-container" *msShowInEpcot="true">
                <ng-container [ngTemplateOutlet]="optionsHeaderTemplate" />
            </div>
            <ng-container *msShowInEpcot="false" [ngTemplateOutlet]="optionsHeaderTemplate" />
        } @else {
            <ng-container [ngTemplateOutlet]="optionsHeaderTemplate" />
        }
    </div>

    @for (optionRow of optionRows; track trackByPlayer(i, optionRow); let i = $index) {
        @if (showSixPackParticipantImages) {
            <ng-container
                *msShowInEpcot="true"
                [ngTemplateOutlet]="optionRowTemplateWithImages"
                [ngTemplateOutletContext]="{ optionRow: optionRow, index: i }" />

            <ng-container
                *msShowInEpcot="false"
                [ngTemplateOutlet]="optionRowTemplateWithoutImages"
                [ngTemplateOutletContext]="{ optionRow: optionRow, index: i }" />
        } @else {
            <ng-container [ngTemplateOutlet]="optionRowTemplateWithoutImages" [ngTemplateOutletContext]="{ optionRow: optionRow, index: i }" />
        }
    }

    @if (optionGroupTeamStatisticsService.isPlayerStatisticsEnabled()) {
        <div class="player-statistics-icon-container">
            <div class="player-statistics-icon" [class.active]="optionGroupTeamStatisticsService.isOpen()" (click)="toggleTeamStatistics($event)">
                <vn-icon size="12" [name]="optionGroupTeamStatisticsService.isOpen() ? 'sports-stats-active' : 'sports-stats'" />
            </div>
        </div>
    }

    @if (
        (!optionGroupTeamStatisticsService.isPlayerStatisticsEnabled() && hasInsights) ||
        (optionGroupTeamStatisticsService.isPlayerStatisticsEnabled() && optionGroupTeamStatisticsService.isOpen() && hasInsights)
    ) {
        <ng-container *msComponentProxy="bettingInsightsComponent" />
    }
    @if (optionGroupTeamStatisticsService.isOpen()) {
        <ms-player-statistics
            [statistics]="optionGroupTeamStatisticsService.playerStatistics()"
            [messages]="playerStatisticsMessages()"
            [event]="event"
            [playerName]="event.name"
            [tracking]="tracking ?? ''"
            [isMainMarket]="true"
            [iFrameHeight]="optionGroupTeamStatisticsService.iFrameHeight()"
            [optionGroupName]="optionGroup.name" />
    }
</div>

<ng-template #optionsHeaderTemplate>
    @for (header of optionHeaders | keyvalue: keepOrder; track $index) {
        <span class="six-pack-col">{{ header.value }}</span>
    }
</ng-template>

<ng-template #optionRowTemplateWithoutImages let-optionRow="optionRow" let-index="index">
    <div class="attribute-key" [class.option-name-stats-container]="showPlayerStats">
        <div class="six-pack-player-name">
            <span>{{ optionRow.player }}</span>
            @if (isMarketPromoted(index)) {
                <ms-promotion-badge class="no-title" />
            }
        </div>
        @if (showPlayerStats) {
            <ng-container *ngTemplateOutlet="playerStatsTemplate; context: { $implicit: optionRow }" />
        }
    </div>

    @for (column of optionRow.columns | keyvalue: keepOrder; track trackByCol($index, column)) {
        @if (isOption(column.value)) {
            <ms-option
                [tracking]="{ source: tracking, moduleType: trackingModuleType }"
                [option]="column.value"
                [optionGroup]="optionGroup"
                [event]="event"
                [showPromoBadge]="isOptionPromoted(column.value)"
                [sourceOfPick]="sourceOfPick"
                [betDetails]="betDetails" />
        } @else {
            <div class="option">
                <span class="empty-option">-</span>
            </div>
        }
    }
</ng-template>

<ng-template #optionRowTemplateWithImages let-optionRow="optionRow" let-index="index">
    <div class="option-row">
        <div class="attribute-key" [class.option-name-stats-container]="showPlayerStats">
            @if (showParticipantImages) {
                <ms-participant-image
                    class="participant-logo"
                    [participantImage]="optionRow.playerImage"
                    [sportId]="event.sport.id"
                    [showFallback]="false"
                    [showLogoColor]="showLogoColor"
                    (logoLoaded)="imageLoaded($event, index)" />
            }

            <div class="six-pack-player-name">
                <span>{{ optionRow.player }}</span>
                @if (isMarketPromoted(index)) {
                    <ms-promotion-badge class="no-title" />
                }
            </div>
            @if (showPlayerStats) {
                <ng-container *ngTemplateOutlet="playerStatsTemplate; context: { $implicit: optionRow }" />
            }
        </div>

        <div class="options-container">
            @for (column of optionRow.columns | keyvalue: keepOrder; track trackByCol($index, column)) {
                @if (isOption(column.value)) {
                    <ms-option
                        [tracking]="{ source: tracking, moduleType: trackingModuleType }"
                        [option]="column.value"
                        [optionGroup]="optionGroup"
                        [event]="event"
                        [showPromoBadge]="isOptionPromoted(column.value)"
                        [sourceOfPick]="sourceOfPick"
                        [betDetails]="betDetails" />
                } @else {
                    <div class="option">
                        <span class="empty-option">-</span>
                    </div>
                }
            }
        </div>
    </div>
</ng-template>

<ng-template #playerStatsTemplate let-optionRow>
    @if (event.playerStats && optionGroup.detailedGrouping.playerStatsProps) {
        <ms-player-stats
            [playerStats]="event.playerStats"
            [sportId]="event.sport.id"
            [playerStatsProps]="optionGroup.detailedGrouping.playerStatsProps"
            [playerIds]="[optionRow.playerId]"
            [source]="optionGroup.source" />
    }
</ng-template>
